import navbar from './navbar';
import settings from './settings';
import sidebar from './sidebar';

export default {
  navbar,
  settings,
  sidebar,
};
